import FIMenuVehicleWarrantyCoverage from './FIMenuVehicleWarrantyCoverage';
import moment from 'moment';
import util from '@core/services/util';
import { VINInfo } from './VINInfo';
import FIMenuCarFax from './FIMenuCarFax';

type WarrantyCoverages = {
	basic: FIMenuVehicleWarrantyCoverage;
	drivetrain: FIMenuVehicleWarrantyCoverage;
	roadside: FIMenuVehicleWarrantyCoverage;
	maintenance: FIMenuVehicleWarrantyCoverage;
};

export default class FIMenuVehicleWarranty {
	warrantyStartDate: any;
	isLoanerIncluded: any;
	isCertified: any;
	warranties: WarrantyCoverages;

	constructor(init?: Partial<FIMenuVehicleWarranty>) {
		if (init) {
			this.warrantyStartDate = init.warrantyStartDate;
			this.isLoanerIncluded = init.isLoanerIncluded;
			this.isCertified = init.isCertified;
			this.warranties = {
				basic: new FIMenuVehicleWarrantyCoverage(init.warranties?.basic),
				drivetrain: new FIMenuVehicleWarrantyCoverage(init.warranties?.drivetrain),
				roadside: new FIMenuVehicleWarrantyCoverage(init.warranties?.roadside),
				maintenance: new FIMenuVehicleWarrantyCoverage(init.warranties?.maintenance),
			};
		} else {
			this.warrantyStartDate = null;
			this.isLoanerIncluded = false;
			this.isCertified = false;
			this.warranties = {
				basic: new FIMenuVehicleWarrantyCoverage(),
				drivetrain: new FIMenuVehicleWarrantyCoverage(),
				roadside: new FIMenuVehicleWarrantyCoverage(),
				maintenance: new FIMenuVehicleWarrantyCoverage(),
			};
		}
	}

	updateUsingVINLookupResponse(vinResponse: VINInfo, carFax?: FIMenuCarFax) {
		this.warranties.basic.miles = null;
		this.warranties.basic.months = null;
		this.warranties.drivetrain.miles = null;
		this.warranties.drivetrain.months = null;
		this.warranties.roadside.miles = null;
		this.warranties.roadside.months = null;
		this.warranties.maintenance.miles = null;
		this.warranties.maintenance.months = null;

		if (vinResponse && vinResponse.warrantyInfo) {
			this.warranties.basic.miles = vinResponse.warrantyInfo.basicMiles;
			this.warranties.basic.months = vinResponse.warrantyInfo.basicMonths;
			this.warranties.drivetrain.miles = vinResponse.warrantyInfo.drivetrainMiles;
			this.warranties.drivetrain.months = vinResponse.warrantyInfo.drivetrainMonths;
			this.warranties.roadside.miles = vinResponse.warrantyInfo.roadsideMiles;
			this.warranties.roadside.months = vinResponse.warrantyInfo.roadsideMonths;
			this.warranties.maintenance.miles = vinResponse.warrantyInfo.maintenanceMiles;
			this.warranties.maintenance.months = vinResponse.warrantyInfo.maintenanceMonths;
		}
	}

	updateUsingVINCarFaxLookup(vinResponse: VINInfo, carFax: FIMenuCarFax) {
		const maximunAllowedDifferenceInYears = 1;

		//Auto-populating WarrantyStartDate
		if (carFax?.warrantyStartDateTime) {
			this.warrantyStartDate = carFax.warrantyStartDateTime;
		}
		//Populating missing warranty info from VinDecoder with CarFax info if available
		if (
			carFax &&
			vinResponse?.warrantyInfo &&
			(!vinResponse.warrantyInfo.basicMiles ||
				!vinResponse.warrantyInfo.basicMonths ||
				!vinResponse.warrantyInfo.drivetrainMiles ||
				!vinResponse.warrantyInfo.drivetrainMonths ||
				!vinResponse.warrantyInfo.roadsideMiles ||
				!vinResponse.warrantyInfo.roadsideMonths)
		) {
			if (!vinResponse.warrantyInfo.basicMiles && carFax.originalBasicMiles) {
				this.warranties.basic.miles = carFax.originalBasicMiles;
			}
			if (!vinResponse.warrantyInfo.basicMonths && carFax.originalBasicMonths) {
				this.warranties.basic.months = carFax.originalBasicMonths;
			}

			if (!vinResponse.warrantyInfo.drivetrainMiles && carFax.originalDrivetrainMiles) {
				this.warranties.drivetrain.miles = carFax.originalDrivetrainMiles;
			}
			if (!vinResponse.warrantyInfo.drivetrainMonths && carFax.originalDrivetrainMonths) {
				this.warranties.drivetrain.months = carFax.originalDrivetrainMonths;
			}

			if (!vinResponse.warrantyInfo.roadsideMiles && carFax.originalRoadsideMiles) {
				this.warranties.roadside.miles = carFax.originalRoadsideMiles;
			}
			if (!vinResponse.warrantyInfo.roadsideMonths && carFax.originalRoadsideMonths) {
				this.warranties.roadside.months = carFax.originalRoadsideMonths;
			}
		}
		if (
			carFax &&
			!vinResponse &&
			(!this.warranties.basic.miles ||
				!this.warranties.basic.months ||
				!this.warranties.drivetrain.miles ||
				!this.warranties.drivetrain.months ||
				!this.warranties.roadside.miles ||
				!this.warranties.roadside.months)
		) {
			this.warranties.basic.miles = carFax.originalBasicMiles;
			this.warranties.basic.months = carFax.originalBasicMonths;
			this.warranties.drivetrain.miles = carFax.originalDrivetrainMiles;
			this.warranties.drivetrain.months = carFax.originalDrivetrainMonths;
			this.warranties.roadside.miles = carFax.originalRoadsideMiles;
		}
	}
}
